import React from 'react';
import ReactDOM from 'react-dom';
import { InputText } from 'primereact/inputtext';
import { MultiSelect } from 'primereact/multiselect';
import { estados } from '../../util/estados';
import './ClienteForm.css';

class ClienteForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            name: '',
            email: '',
            todas_cidades: false,
            city_ids: [],
            selected_states: [],
            cities_options: [],
            errors: {},
            loading: false,
        };
        this.handleSubmit       = this.handleSubmit.bind(this);
        this.handleStatesChange = this.handleStatesChange.bind(this);
    }

    deriveStatesFromCities(cityIds, citiesOptions) {
        const map = {};
        citiesOptions.forEach(group => {
            group.items.forEach(city => { map[city.value] = group.label; });
        });
        return [...new Set((cityIds || []).map(id => map[id]).filter(Boolean))];
    }

    componentDidMount() {
        const clienteId = window.__CLIENTE_ID__;

        this.setState({ loading: true });

        Promise.all([
            axios.get('/cidades/for-select').then(r => r.data),
            axios.get(`/clientes-crud/${clienteId}`).then(r => r.data),
        ]).then(([citiesOptions, clienteData]) => {
            const { name, email, city_ids, cliente_nacional } = clienteData;
            this.setState({
                cities_options:  citiesOptions,
                name:            name || '',
                email:           email || '',
                todas_cidades:   !!cliente_nacional,
                city_ids:        city_ids || [],
                selected_states: this.deriveStatesFromCities(city_ids, citiesOptions),
                loading:         false,
            });
        }).catch(() => this.setState({ loading: false }));
    }

    handleStatesChange(e) {
        const newStates = e.value;
        const { cities_options, city_ids } = this.state;

        const validIds = new Set();
        cities_options
            .filter(g => newStates.includes(g.label))
            .forEach(g => g.items.forEach(c => validIds.add(c.value)));

        this.setState({
            selected_states: newStates,
            city_ids: city_ids.filter(id => validIds.has(id)),
        });
    }

    handleSubmit(e) {
        e.preventDefault();
        const { name, todas_cidades, selected_states, city_ids } = this.state;
        const clienteId = window.__CLIENTE_ID__;

        this.setState({ loading: true, errors: {} });

        axios.put(`/cliente/${clienteId}`, {
            name,
            todas_cidades: todas_cidades ? 'true' : undefined,
            'estado':    todas_cidades ? undefined : selected_states,
            'cidade':    todas_cidades ? undefined : city_ids,
        }).then(response => {
            window.location.href = response.data.redirect;
        }).catch(error => {
            const status = error.response && error.response.status;
            if (status === 400 || status === 422) {
                this.setState({ errors: error.response.data.errors || {}, loading: false });
            } else {
                this.setState({ loading: false });
            }
        });
    }

    render() {
        const {
            name, email, todas_cidades,
            city_ids, selected_states, cities_options,
            errors, loading,
        } = this.state;

        if (loading && !name && !email) {
            return (
                <div className="cliente-form">
                    <div className="ef-loading">
                        <i className="fa fa-spinner fa-spin"></i> Carregando...
                    </div>
                </div>
            );
        }

        const filtered_cities = selected_states.length
            ? cities_options
                .filter(g => selected_states.includes(g.label))
                .flatMap(g => g.items)
            : [];

        return (
            <form className="cliente-form" onSubmit={this.handleSubmit}>
                <fieldset>
                    <div className="form-group row">
                        <div className="col-12">
                            <label className={`ef-label${errors.name ? ' ef-label--error' : ''}`}>Nome*</label>
                            <InputText
                                className={`d-block w-100${errors.name ? ' ef-invalid' : ''}`}
                                name="name"
                                value={name}
                                onChange={e => this.setState({ name: e.target.value })}
                                placeholder="Nome"
                            />
                            {errors.name && <div className="ef-error">{errors.name[0]}</div>}
                        </div>
                    </div>
                </fieldset>

                <fieldset>
                    <div className="form-group row">
                        <div className="col-12">
                            <label className="ef-label">E-mail</label>
                            <InputText
                                className="d-block w-100"
                                name="email"
                                value={email}
                                disabled
                            />
                        </div>
                    </div>
                </fieldset>

                <fieldset>
                    <div className="form-group row">
                        <div className="col-12">
                            <div className="form-check">
                                <label className="form-check-label">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        checked={todas_cidades}
                                        onChange={e => this.setState({ todas_cidades: e.target.checked })}
                                    />
                                    <span className="form-check-sign"></span>
                                    Todas as Cidades
                                </label>
                            </div>
                        </div>
                    </div>
                </fieldset>

                <fieldset>
                    <div className="form-group row">
                        <div className="col-6">
                            <label className={`ef-label${errors.estado ? ' ef-label--error' : ''}`}>Estados</label>
                            <MultiSelect
                                value={selected_states}
                                options={estados}
                                optionLabel="label"
                                optionValue="value"
                                onChange={this.handleStatesChange}
                                placeholder="Selecione os estados"
                                disabled={todas_cidades}
                                filter
                                filterPlaceholder="Buscar estado..."
                                display="chip"
                                className="w-100"
                            />
                            {errors.estado && <div className="ef-error">{errors.estado[0]}</div>}
                        </div>
                        <div className="col-6">
                            <label className="ef-label">Cidades</label>
                            <MultiSelect
                                value={city_ids}
                                options={filtered_cities}
                                optionLabel="label"
                                optionValue="value"
                                onChange={e => this.setState({ city_ids: e.value })}
                                placeholder={selected_states.length ? 'Selecione as cidades' : 'Selecione um estado primeiro'}
                                disabled={todas_cidades || !selected_states.length}
                                filter
                                filterPlaceholder="Buscar cidade..."
                                display="chip"
                                className="w-100"
                            />
                        </div>
                    </div>
                </fieldset>

                <fieldset>
                    <div className="form-group">
                        <button
                            type="submit"
                            className="btn btn-warning ef-submit-btn"
                            disabled={loading}
                        >
                            {loading ? <><i className="fa fa-spinner fa-spin"></i> Aguarde...</> : 'Salvar alterações'}
                        </button>
                    </div>
                </fieldset>
            </form>
        );
    }
}

const mountPoint = document.getElementById('js-cliente-form');
if (mountPoint) {
    ReactDOM.render(<ClienteForm />, mountPoint);
}
